function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useContext } from 'react';
import { connect, useSelector } from 'react-redux';
import { posActions } from '../../../reducers/pos.reducer';
import PageData from './Page.context';
import useEnvArr from '../../../helpers/hooks/useEnvArr';
import Card from '../../common/card/Card.react';
import CardHeader from '../../common/card/CardHeader.react';
import CardBody from '../../common/card/CardBody.react';
import Label from '../../common/form/Label.react';
import Input from '../../common/form/Input.react';
import Checkbox from '../../common/form/Checkbox.react';
import Button from '../../common/Button.react';
import Select from '../../common/form/Select.react';
import SelectPageItemContact from '../../common/form/select/SelectPageItemContact.react';
var PageDetails = function PageDetails(_ref) {
  var pagesAction = _ref.pagesAction;
  var _useContext = useContext(PageData),
    _useContext2 = _slicedToArray(_useContext, 2),
    state = _useContext2[0],
    setState = _useContext2[1];
  var app = state.app,
    type = state.type,
    title = state.title,
    internalUrl = state.internalUrl,
    articleType = state.articleType,
    published = state.published,
    sidebar = state.sidebar,
    calculator = state.calculator,
    contactPerson = state.contactPerson,
    topNavBar = state.topNavBar,
    bottomNavBar = state.bottomNavBar,
    archived = state.archived;
  var pageTypes = [{
    type: 'article-page',
    label: 'Article Page'
  }, {
    type: 'react-component',
    label: 'Custom React Component'
  }];
  var articleTypesArr = useSelector(function (s) {
    return s.settings.constants.articleTypes || [];
  });
  var environmentsArr = useSelector(function (s) {
    return s.settings.constants.environments || [];
  });
  var envArr = useEnvArr();
  var isValid = function isValid() {
    return (title === null || title === void 0 ? void 0 : title.length) > 0 && (internalUrl === null || internalUrl === void 0 ? void 0 : internalUrl.length) > 0;
  };
  var updateState = function updateState(key, value) {
    return setState(_objectSpread(_objectSpread({}, state), {}, _defineProperty({}, key, value)));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Section Details"
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Label, {
    label: "Title",
    required: true,
    info: "Section Title. This will not be published, but is used to organize your application's pages"
  }), /*#__PURE__*/React.createElement(Input, {
    value: title,
    onChange: function onChange(e) {
      return updateState('title', e.target.value);
    },
    permission: "edit-pos-sections"
  }), /*#__PURE__*/React.createElement(Label, {
    label: "URL",
    required: true
  }), /*#__PURE__*/React.createElement(Input, {
    value: internalUrl,
    onChange: function onChange(e) {
      return updateState('internalUrl', e.target.value.replace(/ /g, '').replace(/[^a-z/-]/g, ''));
    },
    permission: "edit-pos-sections"
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Page Type",
    required: true
  }), /*#__PURE__*/React.createElement(Select, {
    value: type,
    options: pageTypes.map(function (x) {
      return {
        sValue: x.type,
        sLabel: x.label
      };
    }),
    onChange: function onChange(_ref2) {
      var sValue = _ref2.sValue;
      return updateState('type', sValue);
    },
    permission: "edit-pos-sections"
  }), type === 'article-page' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Label, {
    label: "Default Article Type",
    required: true
  }), /*#__PURE__*/React.createElement(Select, {
    value: articleType,
    options: articleTypesArr.sort(function (a, b) {
      return a.name.localeCompare(b.name);
    }).map(function (x) {
      return {
        sValue: x.value,
        sLabel: x.description
      };
    }),
    onChange: function onChange(_ref3) {
      var sValue = _ref3.sValue;
      return updateState('articleType', sValue);
    },
    permission: "edit-pos-sections"
  })), /*#__PURE__*/React.createElement(Label, {
    label: "Published"
  }), environmentsArr.filter(function (x) {
    return x.clientApp === app.toLowerCase() && envArr.includes(x.key);
  }).map(function (x) {
    return /*#__PURE__*/React.createElement(Checkbox, {
      checked: published[x.key],
      label: x.name,
      onChange: function onChange(v) {
        return updateState('published', _objectSpread(_objectSpread({}, published), {}, _defineProperty({}, x.key, v)));
      },
      permission: "edit-pos-sections",
      key: "published".concat(x.key)
    });
  })), /*#__PURE__*/React.createElement(CardHeader, {
    title: "Section Settings"
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Checkbox, {
    checked: sidebar === null || sidebar === void 0 ? void 0 : sidebar.isVisible,
    label: "Show Sidebar",
    onChange: function onChange(v) {
      return updateState('sidebar', _objectSpread(_objectSpread({}, sidebar), {}, {
        isVisible: v
      }));
    },
    permission: "edit-pos-sections"
  }), /*#__PURE__*/React.createElement(Checkbox, {
    checked: calculator,
    label: "Show Materials Calculator",
    onChange: function onChange(v) {
      return updateState('calculator', v);
    },
    permission: "edit-pos-sections"
  }), /*#__PURE__*/React.createElement(Checkbox, {
    checked: topNavBar,
    label: "Show Top Navigation",
    onChange: function onChange(v) {
      if (bottomNavBar.isVisible && bottomNavBar.position === 'top') return;
      updateState('topNavBar', v);
    },
    permission: "edit-pos-sections"
  }), /*#__PURE__*/React.createElement(Checkbox, {
    checked: contactPerson === null || contactPerson === void 0 ? void 0 : contactPerson.isVisible,
    label: "Show Contact Person",
    onChange: function onChange(v) {
      return updateState('contactPerson', _objectSpread(_objectSpread({}, contactPerson), {}, {
        isVisible: v
      }));
    },
    permission: "edit-pos-sections"
  }), /*#__PURE__*/React.createElement(Checkbox, {
    checked: bottomNavBar === null || bottomNavBar === void 0 ? void 0 : bottomNavBar.isVisible,
    label: "Show Bottom Navigation",
    onChange: function onChange(isVisible) {
      return updateState('bottomNavBar', _objectSpread(_objectSpread({}, bottomNavBar), {}, {
        isVisible: isVisible
      }));
    },
    permission: "edit-pos-sections"
  })), (bottomNavBar === null || bottomNavBar === void 0 ? void 0 : bottomNavBar.isVisible) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Bottom Nav Bar Position"
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Select, {
    value: bottomNavBar.position,
    options: [{
      sValue: 'top',
      sLabel: 'Top'
    }, {
      sValue: 'bottom',
      sLabel: 'Bottom'
    }],
    onChange: function onChange(_ref4) {
      var sValue = _ref4.sValue;
      setState(_objectSpread(_objectSpread({}, state), {}, {
        bottomNavBar: _objectSpread(_objectSpread({}, bottomNavBar), {}, {
          position: sValue
        }),
        topNavBar: sValue === 'top' ? false : topNavBar
      }));
    },
    permission: "edit-pos-sections"
  }))), sidebar.isVisible && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Sidebar Title"
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Label, {
    label: "Title"
  }), /*#__PURE__*/React.createElement(Input, {
    value: sidebar === null || sidebar === void 0 ? void 0 : sidebar.title,
    onChange: function onChange(e) {
      return updateState('sidebar', _objectSpread(_objectSpread({}, sidebar), {}, {
        title: e.target.value
      }));
    },
    permission: "edit-pos-sections"
  }))), contactPerson.isVisible && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Contact Person"
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Label, {
    label: "Title",
    required: true
  }), /*#__PURE__*/React.createElement(Input, {
    value: contactPerson === null || contactPerson === void 0 ? void 0 : contactPerson.title,
    onChange: function onChange(e) {
      return updateState('contactPerson', _objectSpread(_objectSpread({}, contactPerson), {}, {
        title: e.target.value
      }));
    },
    permission: "edit-pos-sections"
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Contact Person"
  }), /*#__PURE__*/React.createElement(SelectPageItemContact, {
    value: contactPerson === null || contactPerson === void 0 ? void 0 : contactPerson.contactID,
    onChange: function onChange(contactID) {
      return updateState('contactPerson', _objectSpread(_objectSpread({}, contactPerson), {}, {
        contactID: contactID
      }));
    },
    permission: "edit-pos-sections"
  }))), !archived && /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement("div", {
    className: "a__btns"
  }, /*#__PURE__*/React.createElement(Button, {
    label: "Save",
    onClick: function onClick() {
      pagesAction({
        formData: {
          pageID: state.pageID,
          title: state.title,
          internalUrl: state.internalUrl,
          type: state.type,
          articleType: state.articleType,
          published: state.published,
          sidebar: state.sidebar,
          calculator: state.calculator,
          contactPerson: state.contactPerson,
          topNavBar: state.topNavBar,
          bottomNavBar: state.bottomNavBar
        },
        // formData: state,
        method: 'put'
      });
    },
    disabled: !isValid(),
    permission: "edit-pos-sections"
  })))));
};
var mdtp = {
  pagesAction: posActions.pages
};
export default connect(null, mdtp)(PageDetails);